import twelvedata from "twelvedata";

export default class Stocks {
  constructor(element) {
    this.element = element;

    this.symbolName = {
      AAPL: "Apple Inc",
      BTC: "Bitcoin US Dollar",
      GOOG: "Alphabet Inc",
      META: "Meta Platforms",
      MSFT: "Microsoft Corp",
      NVDA: "Nvidia Corp",
      TSLA: "Tesla Inc"
    };

    this.init();
  }

  init() {
    console.log("Stocks market");

    const config = {
      key: process.env.API_KEY_TWELVEDATA
    };

    this.client = twelvedata(config);
    this.askStocks();
  }

  askStocks() {
    this.client.timeSeries({
      symbol: ["AAPL", "BTC/USD", "GOOG", "META", "MSFT", "NVDA", "TSLA"],
      interval: "1min",
      outputsize: 1
    }).then(response => {

      // Validate response before sending it to the server
      try {
        const jsonResponse = JSON.stringify(response);

        fetch("/dashboard/models/store_stocks.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: jsonResponse
        })
          .then(response => console.log(response))
          .then(data => {
            console.log("Success:", data);
            this.fetchStoredStocks();
          })
          .catch(error => {
            console.error("Error:", error);
          });
      } catch (jsonError) {
        console.error("JSON Error:", jsonError);
      }
    }).catch(apiError => {
      console.error("API Error:", apiError);
    });
  }

  fetchStoredStocks() {
    fetch("/dashboard/controllers/get_stocks.php")
      .then(response => response.json())
      .then(data => {
        const listStocks = document.querySelectorAll(".stocks-js");
        listStocks.forEach(element => {
          for (let stock of data) {
            if (element.id === stock.symbol) {
              element.querySelector(".dashboard__card__symbol").textContent = stock.symbol;
              element.querySelector(".dashboard__card__name").textContent = this.symbolName[stock.symbol];
              element.querySelector(".price__span").textContent = parseFloat(stock.price).toFixed(2);
              element.querySelector(".low__span").textContent = parseFloat(stock.low).toFixed(2);
              element.querySelector(".high__span").textContent = parseFloat(stock.high).toFixed(2);
            }
          }
        });
      })
      .catch(error => {
        console.error("Error:", error);
      });
  }
}
